<!--FDC场景推荐弹框-->
<template>
  <el-dialog title="" :visible.sync="visible" :close-on-click-modal="false" width="890px" class="scene-dialog"
    :before-close="handleClose" append-to-body>
    <div class="scene-header">
      <div class="scene-header-left">
        <div class="scene-title">✦ 推荐场景</div>
        <div class="scene-sub">根据典型使用场景一键勾选功能模块，选后可手动调整</div>
      </div>
    </div>
    <div class="scene-body" v-loading="loading">
      <div class="scene-arrow scene-arrow-left" :class="{ disabled: scrollIndex <= 0 }" @click="scrollLeft">
        <i class="el-icon-arrow-left"></i>
      </div>
      <div class="scene-track">
        <div class="scene-track-inner" :style="{ transform: 'translateX(-' + scrollIndex * (cardWidth + cardGap) + 'px)' }">
          <div v-for="item in sceneList" :key="item.id" class="scene-card"
            :class="{ selected: selectedId === item.id }" @click="selectScene(item)">
            <div class="selected-mark" v-if="selectedId === item.id">
              <i class="el-icon-check"></i>
            </div>
            <div class="scene-name">{{ item.name }}</div>
            <div class="scene-desc">{{ item.description }}</div>
            <div class="info-block">
              <div class="info-label">包含功能模块</div>
              <div class="module-tags">
                <span class="mtag" v-for="code in item.modules" :key="code">{{ getModuleName(code) }}</span>
              </div>
            </div>
            <div class="info-block">
              <div class="info-label">推荐用户许可</div>
              <div class="user-recommend">
                工作用户 <span class="ured">{{ item.bi_users }}</span> 人 · 查看用户 <span class="ured">{{ item.std_users }}</span> 人
              </div>
            </div>
            <div class="scene-select-btn" @click.stop="selectScene(item)">
              {{ selectedId === item.id ? '✓ 已选择' : '选择此场景' }}
            </div>
          </div>
        </div>
      </div>
      <div class="scene-arrow scene-arrow-right" :class="{ disabled: scrollIndex >= maxScrollIndex }" @click="scrollRight">
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="confirmScene">确认选择并应用</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getFDCSceneSimpleList } from '@/api/afFdc';

export default {
  props: {
    modulesList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
      sceneList: [],
      selectedId: null,
      scrollIndex: 0,
      cardWidth: 250,
      cardGap: 16,
      visibleCount: 3,
    };
  },
  computed: {
    maxScrollIndex() {
      return Math.max(0, this.sceneList.length - this.visibleCount);
    },
  },
  methods: {
    show() {
      this.visible = true;
      this.selectedId = null;
      this.scrollIndex = 0;
      this.getScenes();
    },
    getScenes() {
      this.loading = true;
      getFDCSceneSimpleList().then(res => {
        this.sceneList = res || [];
        this.loading = false;
      }).catch(() => {
        this.sceneList = [];
        this.loading = false;
      });
    },
    getModuleName(code) {
      const mod = this.modulesList.find(m => m.code === code);
      return mod ? mod.name : code;
    },
    selectScene(item) {
      this.selectedId = this.selectedId === item.id ? null : item.id;
    },
    scrollLeft() {
      if (this.scrollIndex > 0) this.scrollIndex--;
    },
    scrollRight() {
      if (this.scrollIndex < this.maxScrollIndex) this.scrollIndex++;
    },
    confirmScene() {
      if (!this.selectedId) {
        this.$message.warning('请先选择一个场景');
        return;
      }
      const scene = this.sceneList.find(s => s.id === this.selectedId);
      if (scene) {
        this.$emit('apply', scene);
      }
      this.visible = false;
    },
    handleClose() {
      this.visible = false;
    },
  },
};
</script>

<style scoped>
.scene-dialog >>> .el-dialog__header {
  padding: 0;
  display: none;
}
.scene-dialog >>> .el-dialog__body {
  padding: 24px 28px 0;
}
.scene-header {
  margin-bottom: 20px;
}
.scene-title {
  font-size: 18px;
  font-weight: 700;
  color: #1a2233;
}
.scene-sub {
  font-size: 13px;
  color: #888;
  margin-top: 4px;
}
.scene-body {
  display: flex;
  align-items: center;
  position: relative;
  min-height: 200px;
}
.scene-track {
  overflow: hidden;
  flex: 1;
}
.scene-track-inner {
  display: flex;
  gap: 16px;
  transition: transform .3s ease;
}
.scene-card {
  flex-shrink: 0;
  width: 203px;
  border: 2px solid #e8edf5;
  border-radius: 10px;
  padding: 20px 16px;
  cursor: pointer;
  transition: all .18s;
  position: relative;
  display: flex;
  flex-direction: column;
}
.scene-card:hover {
  border-color: #91acff;
  background: #f7f9ff;
}
.scene-card.selected {
  border-color: #409eff;
  background: #f0f7ff;
}
.selected-mark {
  position: absolute;
  top: -1px;
  right: -1px;
  width: 24px;
  height: 24px;
  background: #409eff;
  border-radius: 0 8px 0 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 14px;
}
.scene-name {
  font-size: 16px;
  font-weight: 700;
  color: #1a2233;
  margin-bottom: 8px;
}
.scene-desc {
  font-size: 12px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 12px;
}
.info-block {
  margin-bottom: 10px;
}
.info-label {
  font-size: 12px;
  color: #999;
  margin-bottom: 6px;
  font-weight: 500;
}
.module-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
.mtag {
  font-size: 11px;
  color: #409eff;
  background: #ecf5ff;
  border-radius: 3px;
  padding: 2px 6px;
}
.user-recommend {
  font-size: 12px;
  color: #555;
}
.user-recommend .ured {
  color: #e84545;
  font-weight: 600;
}
.scene-select-btn {
  margin-top: auto;
  padding-top: 12px;
  text-align: center;
  border: 1.5px solid #d8dff0;
  border-radius: 6px;
  padding: 8px;
  font-size: 13px;
  color: #555;
  cursor: pointer;
  transition: all .15s;
}
.scene-select-btn:hover {
  border-color: #409eff;
  color: #409eff;
}
.scene-card.selected .scene-select-btn {
  background: #409eff;
  border-color: #409eff;
  color: #fff;
}
.scene-arrow {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #fff;
  border: 1px solid #dcdfe6;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  font-size: 16px;
  color: #606266;
  box-shadow: 0 2px 6px rgba(0,0,0,.1);
  transition: all .15s;
  z-index: 1;
}
.scene-arrow:hover {
  background: #409eff;
  border-color: #409eff;
  color: #fff;
}
.scene-arrow.disabled {
  background: #f5f7fa;
  border-color: #e4e7ed;
  color: #c0c4cc;
  cursor: not-allowed;
  box-shadow: none;
}
.scene-arrow.disabled:hover {
  background: #f5f7fa;
  border-color: #e4e7ed;
  color: #c0c4cc;
}
.scene-arrow-left {
  margin-right: 8px;
}
.scene-arrow-right {
  margin-left: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/agileFlow/sceneDialog.vue